import axios from 'axios';

import * as t from './types';

export const FilesApi = {
  uploadFile: async ({ file, url }: t.IUploadFileParams) => {
    await axios.put(url, file, {
      headers: { 'Content-Type': file.type },
    });
  },
};
